<vue-slider class="root tw-slider" v-bind="sliderOptions" :value="value" @update:modelValue="$emit('update:value', $event)" />
